import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import VenueDetail from "@/pages/VenueDetail";
import SEOLandingPage from "@/pages/SEOLandingPage";

/**
 * URL /venues/{country}/{city}/{slug} could be either a venue detail
 * or an area SEO landing page. Try venue first, fallback to landing.
 */
export default function VenueOrArea() {
    const { country_slug, city_slug, venue_slug } = useParams();
    const [type, setType] = useState(null); // 'venue' | 'area'

    useEffect(() => {
        setType(null);
        api.get(`/venues/by-slug/${country_slug}/${city_slug}/${venue_slug}`)
            .then(() => setType("venue"))
            .catch(() => setType("area"));
    }, [country_slug, city_slug, venue_slug]);

    if (!type) return <div className="container-app py-24"><div className="h-8 w-1/3 bg-muted/50 rounded animate-pulse" /></div>;
    return type === "venue" ? <VenueDetail /> : <SEOLandingPage />;
}
